export enum DocumentType {
    drawing = 0,
    property = 1,
    development = 2,
}
